import { type BtnType } from '@/src/Types/Shared/Button';
import {
	ArrowBold,
	ArrowFull,
	ArrowLong,
	ArrowSmall,
	OpenNewTabIcon,
} from '@/src/Views/Shared/Icons';
import { Link } from '@inertiajs/react';

import { __Front } from '../lib';
import { Animation } from './Animation';

export function Button(props: BtnType) {
	return (
		<>
			{props.btnClassName?.btnStyle?.btnIsBasicLink ? (
				<BasicBtn {...props} />
			) : (
				<Complexbtn {...props} />
			)}
		</>
	);
}

const BasicBtn = (props: BtnType) => {
	const {
		label,
		url,
		style = 'primary',
		urlOpenNewTab = false,
		children,
		className = '',
		btnClassName,
		urlType = 'link',
	} = props;

	const classes: string[] = [];

	const basicStyle = `group relative inline-block transition-colors last:mr-0 w-fit`;

	let positionStyle = '';

	// if parentNode as a style = text-align = center | right
	if (className) {
		if (className.includes('center')) positionStyle = '!mx-auto !mt-3';
		if (className.includes('right')) positionStyle = '!ml-auto !mt-3';
	} else {
		positionStyle = '';
	}

	if (style === 'a') {
		classes.push(
			`${className} ${urlOpenNewTab ? 'inline-flex gap-1 items-center' : ''}  ${btnClassName?.btnStyle?.btnHasIcon && btnClassName?.btnStyle?.btnDecorationElement === 'underline' ? ' underline underline-offset-4' : ''}`
		);
	} else {
		classes.push(
			btnClassName?.ClassName ? btnClassName?.ClassName : '',
			basicStyle,
			'',
			positionStyle
		);
	}

	classes.push(
		`${btnClassName?.ClassName ? btnClassName?.ClassName : ''} ${btnClassName?.btnStyle?.hasUnderline ? ' underline underline-offset-4' : ''}`
	);

	const linkOpenNewTab = style === 'a' && urlOpenNewTab;

	return (
		<>
			{url && (
				<>
					{linkOpenNewTab ? (
						<a
							href={url}
							rel={urlOpenNewTab ? 'noopener noreferrer' : url}
							target={urlOpenNewTab ? '_blank' : '_self'}
							className={classes.join(' ')}
						>
							{children ? <>{children}</> : label}

							{linkOpenNewTab ? (
								<>
									<span className='sr-only'>&nbsp;-&nbsp;{__Front('front.openNewTab')}</span>
									<span title={__Front('front.openNewTab')} aria-hidden='true'>
										<OpenNewTabIcon />
									</span>
								</>
							) : (
								''
							)}
						</a>
					) : urlType === 'link' && !urlOpenNewTab ? (
						<a
							href={url}
							rel={urlOpenNewTab ? 'noopener noreferrer' : url}
							target={urlOpenNewTab ? '_blank' : '_self'}
							className={classes.join(' ')}
						>
							{children ? <>{children}</> : label}
						</a>
					) : (
						<Link
							href={url}
							rel={urlOpenNewTab ? 'noopener noreferrer' : url}
							target={urlOpenNewTab ? '_blank' : '_self'}
							className={classes.join(' ')}
						>
							{children ? <>{children}</> : label}

							{linkOpenNewTab ? (
								<>
									<span className='sr-only'>&nbsp;-&nbsp;{__Front('front.openNewTab')}</span>
									<span title={__Front('front.openNewTab')} aria-hidden='true'>
										<OpenNewTabIcon />
									</span>
								</>
							) : (
								''
							)}
						</Link>
					)}
				</>
			)}
		</>
	);
};

const Complexbtn = (props: BtnType) => {
	const {
		label,
		url,
		urlOpenNewTab = false,
		urlType = 'link',
		children,
		className = '',
		btnClassName,
	} = props;

	const classes: string[] = [];

	const basicStyle = `group relative inline-block transition-colors last:mr-0 w-fit`;

	let positionStyle = '';

	if (className) {
		if (className.includes('center')) positionStyle = '!mx-auto !mt-3';
		if (className.includes('right')) positionStyle = '!ml-auto !mt-3';
	} else {
		positionStyle = '';
	}

	classes.push(
		btnClassName?.ClassName ? btnClassName?.ClassName : '',
		basicStyle,
		'',
		positionStyle
	);

	return (
		<>
			{url && (
				<Animation
					urlType={urlType}
					rel={urlOpenNewTab ? 'noopener noreferrer' : url}
					animation={btnClassName?.btnStyle?.animation}
					href={url}
					className={`${classes.join(' ')} inline-flex items-center justify-center gap-2`}
					target={urlOpenNewTab ? '_blank' : '_self'}
				>
					{children ? (
						<>{children}</>
					) : (
						<>
							<span
								className={`${btnClassName?.btnStyle?.btnHasIcon && btnClassName?.btnStyle?.btnDecorationElement === 'underline' ? 'underline underline-offset-4' : ''}`}
							>
								{label}
							</span>

							{urlOpenNewTab && (
								<>
									<span className='sr-only'>&nbsp;-&nbsp;{__Front('front.openNewTab')}</span>
									<span title={__Front('front.openNewTab')} aria-hidden='true'>
										<OpenNewTabIcon />
									</span>
								</>
							)}
						</>
					)}
					{btnClassName?.btnStyle?.btnHasIcon && !urlOpenNewTab ? (
						<>
							{btnClassName?.btnStyle?.btnDecorationElement === 'long' && (
								<ArrowLong
									width='20'
									className='transition-transform group-hover:translate-x-2 group-hover:duration-300 group-hover:ease-in-out'
								/>
							)}

							{btnClassName?.btnStyle?.btnDecorationElement === 'short' && (
								<ArrowSmall className='transition-transform group-hover:translate-x-2 group-hover:duration-300 group-hover:ease-in-out' />
							)}

							{btnClassName?.btnStyle?.btnDecorationElement === 'bold' && (
								<ArrowBold className='transition-transform group-hover:translate-x-2 group-hover:duration-300 group-hover:ease-in-out' />
							)}

							{btnClassName?.btnStyle?.btnDecorationElement === 'full' && (
								<ArrowFull className='transition-transform group-hover:translate-x-2 group-hover:duration-300 group-hover:ease-in-out' />
							)}
						</>
					) : null}
				</Animation>
			)}
		</>
	);
};
